<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    center
    :before-close="onClose"
  >
    <div style="margin: 20px; text-align: center" v-if="loading">
      <div style="margin: 20px; text-align: center">
        <img src="/img/frameloader.gif" width="48" />
      </div>
      <p>
        {{
          $t('Audiences_Segment_DialogMembersExportRun_Text_PreparingSegment')
        }}
      </p>
      <div>
        <div class="m-top-50">
          <p>{{ $t('Audiences_Segment_DialogMembersExportRun_Question') }}</p>
          <p>
            {{ $t('Audiences_Segment_DialogMembersExportRun_Alert') }}
          </p>
        </div>
        <div slot="footer" class="dialog-footer m-top-25">
          <!--          <el-button type="danger" plain @click="cancel">
            {{ $t('Audiences_Segment_DialogMembersExportRun_CancelBtn') }}
          </el-button>-->
          <el-button type="primary" plain @click="checkLater">
            {{ $t('Audiences_Segment_DialogMembersExportRun_LaterBtn') }}
          </el-button>
        </div>
      </div>
    </div>
    <div style="margin: 100px 0; text-align: center" v-else>
      <p>
        {{ $t('Audiences_Segment_DialogMembersExportRun_Text_DownloadReady') }}
      </p>
      <br />
      <el-button type="primary" @click="download()">
        {{ $t('Audiences_Segment_DialogMembersExportRun_Button_Download') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/core/EventBus'
import fileDownloadMixin from '@/modules/audiences/mixins/fileDownloadMixin'
export default {
  name: 'MembersExportRunDialog',
  mixins: [fileDownloadMixin],
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      task_id: null
    }
  },
  computed: {
    loading() {
      if (this.task.hasOwnProperty('status') && this.task.status === 2) {
        return false
      }
      return true
    }
  },
  methods: {
    download() {
      this.downloadTaskFile(this.task).then(() => {
        this.onClose()
      })
    },
    checkLater() {
      this.onClose()
    },
    cancel() {
      EventBus.$emit('export-members-cancel')
      this.onClose()
    },
    onClose() {
      EventBus.$emit('export-members-run-hide')
      EventBus.$emit('export-members-add-attributes-hide')
      EventBus.$emit('export-members-hide')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/MembersExportRunDialog.vue